import { render, staticRenderFns } from "./merchant-account-details.container.vue?vue&type=template&id=d36f8c40&scoped=true&lang=pug"
import script from "./merchant-account-details.container.vue?vue&type=script&lang=ts"
export * from "./merchant-account-details.container.vue?vue&type=script&lang=ts"
import style0 from "./merchant-account-details.container.vue?vue&type=style&index=0&id=d36f8c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36f8c40",
  null
  
)

export default component.exports